export default __webpack_public_path__ + "static/media/logosm2026.1419ad50.jpg";